import { Component, Input, OnInit, Output, EventEmitter, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisAuthService } from '../../../auth/service/his-auth.service';
import { HisBaseGlobalsService } from '../../service/base/his-base-globals.service';

@Component( {
    selector: 'his-header',
    templateUrl: './his-header.component.html',
    styleUrls: ['./his-header.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisHeaderComponent implements OnInit {
    hisBaseGlobalsService = inject(HisBaseGlobalsService);
    private hisAuthService = inject(HisAuthService);


    @Input() menuButtonText: boolean;
    @Output() menuButton = new EventEmitter<void>();
    public hasMegaMenu: boolean;
    public isMobile: boolean;
    public isAnonymous: boolean;

    ngOnInit() {
        this.isAnonymous = this.hisAuthService.isAnonymous;
        this.hasMegaMenu = this.hisBaseGlobalsService.getMenuType() === 'megaMenu';
        this.isMobile = this.hisBaseGlobalsService.getCurrentDevice() === 'mobile';
    }

    onMenuButton() {
        this.menuButton.emit( null );
    }
}
